import {
  GET_ALL_COUNTRIES_SUCCESS,
  GET_ALL_ENUMERATIONS_SUCCESS,
  GET_ALL_PROVINCES_SUCCESS,
  GET_AUTH_CF_FAILURE,
  GET_AUTH_CF_REQUEST,
  GET_AUTH_CF_SUCCESS,
  GET_AUTH_DOCS_FAILURE,
  GET_AUTH_DOCS_REQUEST,
  GET_AUTH_DOCS_SUCCESS,
  GET_BUS_CODES_FAILURE,
  GET_BUS_CODES_REQUEST,
  GET_BUS_CODES_SUCCESS,
  GET_CLIENT_FIELDS_FAILURE,
  GET_CLIENT_FIELDS_REQUEST,
  GET_CLIENT_FIELDS_SUCCESS,
  GET_CLIENT_FIELDVAL_FAILURE,
  GET_CLIENT_FIELDVAL_REQUEST,
  GET_CLIENT_FIELDVAL_SUCCESS,
  GET_COUNTRIES_FAILURE,
  GET_COUNTRIES_REQUEST,
  GET_COUNTRIES_SUCCESS,
  GET_PENDING_APPROVAL_AUTHORIZATIONS_FAILURE,
  GET_PENDING_APPROVAL_AUTHORIZATIONS_REQUEST,
  GET_PENDING_APPROVAL_AUTHORIZATIONS_SUCCESS,
  GET_PENDING_AUTHORIZATION_FAILURE,
  GET_PENDING_AUTHORIZATION_REQUEST,
  GET_PENDING_AUTHORIZATION_SUCCESS,
  GET_RELO_POLICY_FAILURE,
  GET_RELO_POLICY_REQUEST,
  GET_RELO_POLICY_SUCCESS,
  GET_STATES_FAILURE,
  GET_STATES_REQUEST,
  GET_STATES_SUCCESS,
  GET_TEMP_AUTH_FILES_FAILURE,
  GET_TEMP_AUTH_FILES_REQUEST,
  GET_TEMP_AUTH_FILES_SUCCESS,
  GET_TEMP_FILES_BY_MONTH_FAILURE,
  GET_TEMP_FILES_BY_MONTH_REQUEST,
  GET_TEMP_FILES_BY_MONTH_SUCCESS,
  GET_TEMP_FILES_BY_PROGRAM_FAILURE,
  GET_TEMP_FILES_BY_PROGRAM_REQUEST,
  GET_TEMP_FILES_BY_PROGRAM_SUCCESS,
  GET_PENDING_AUTH_FILE_REQUEST,
  GET_PENDING_AUTH_FILE_SUCCESS,
  GET_PENDING_AUTH_FILE_FAILURE,
  INSERT_AUTH_FAILURE,
  INSERT_AUTH_REQUEST,
  INSERT_AUTH_SUCCESS,
  GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_REQUEST,
  GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_SUCCESS,
  GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_FAILURE,
  GET_CLIENT_INFORMATION_REQUEST,
  GET_CLIENT_INFORMATION_SUCCESS,
  GET_CLIENT_INFORMATION_FAILURE,
  GET_PENDING_AUTH_FILES_DOCS_REQUEST,
  GET_PENDING_AUTH_FILES_DOCS_SUCCESS,
  GET_PENDING_AUTH_FILES_DOCS_FAILURE,
} from './authorizations.actions';
import Immutable from 'immutable';

import { defaultMonthData } from '../../utilities/monthData';
import { sortCountries, sortProvinces } from '../../utilities/enumSorting';

const initialState = Immutable.Map({
  pendingAuthorizations: [],
  pendingApprovalAuthorizations: [],
  pendingAuthorization: [],
  countries: [],
  authCustomFields: [],
  clientFields: [], 
  clientFieldValues: [],
  isLoading: false,
  reloPolicies: [],
  isLoadingApprovalAuthorization: false,
  isLoadingSubmittedAuths: false,
  allEnums: null,
  countryEnums: null,
  provinceEnums: null,
  clientInfo: [],
  authDocuments: [],
});

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_PENDING_APPROVAL_AUTHORIZATIONS_REQUEST:
      return state.set('isLoadingApprovalAuthorization', true);

    case GET_PENDING_APPROVAL_AUTHORIZATIONS_SUCCESS:
      return state
        .set('pendingApprovalAuthorizations', action.response)
        .set('isLoadingApprovalAuthorization', false);

    case GET_PENDING_APPROVAL_AUTHORIZATIONS_FAILURE:
      return state.set('isLoadingApprovalAuthorization', false);

    case GET_COUNTRIES_REQUEST:
      return state.set('isLoading', true);

    case GET_COUNTRIES_SUCCESS:
      return state.set('countries', action.response).set('isLoading', false);

    case GET_COUNTRIES_FAILURE:
      return state.set('isLoading', false);

    case GET_STATES_REQUEST:
      return state.set('isLoading', true);

    case GET_STATES_SUCCESS:
      return state.set('states', action.response).set('isLoading', false);

    case GET_STATES_FAILURE:
      return state.set('isLoading', false);

    case GET_AUTH_CF_REQUEST:
      return state.set('isLoading', true);

    case GET_AUTH_CF_SUCCESS:
      return state
        .set('authCustomFields', action.response)
        .set('isLoading', false);

    case GET_AUTH_CF_FAILURE:
      return state.set('isLoading', false);

    case GET_CLIENT_FIELDS_REQUEST:
      return state.set('isLoading', true);

    case GET_CLIENT_FIELDS_SUCCESS:
      return state.set('clientFields', action.response).set('isLoading', false);

    case GET_CLIENT_FIELDS_FAILURE:
      return state.set('isLoading', false);

    case GET_CLIENT_FIELDVAL_REQUEST:
      return state.set('isLoading', true);

    case GET_CLIENT_FIELDVAL_SUCCESS:
      return state
        .set('clientFieldValues', action.response)
        .set('isLoading', false);

    case GET_CLIENT_FIELDVAL_FAILURE:
      return state.set('isLoading', false);

    case GET_PENDING_AUTHORIZATION_REQUEST:
      return state.set('isLoading', true);

    case GET_PENDING_AUTHORIZATION_SUCCESS:
      return state
        .set('pendingAuthorization', action.response)
        .set('isLoading', false);

    case GET_PENDING_AUTHORIZATION_FAILURE:
      return state.set('isLoading', false);

    case GET_RELO_POLICY_REQUEST:
      return state.set('isLoading', true);

    case GET_RELO_POLICY_SUCCESS:
      return state.set('reloPolicies', action.response).set('isLoading', false);

    case GET_RELO_POLICY_FAILURE:
      return state.set('isLoading', false);

    case GET_BUS_CODES_REQUEST:
      return state.set('isLoading', true);

    case GET_BUS_CODES_SUCCESS:
      return state.set('busCodes', action.response).set('isLoading', false);

    case GET_BUS_CODES_FAILURE:
      return state.set('isLoading', false);

    case GET_AUTH_DOCS_REQUEST:
      return state.set('isLoading', true);

    case GET_AUTH_DOCS_SUCCESS:
      return state
        .set('authDocuments', action.response)
        .set('isLoading', false);

    case GET_AUTH_DOCS_FAILURE:
      return state.set('isLoading', false);

    case INSERT_AUTH_REQUEST:
      return state.set('isLoading', true);

    case INSERT_AUTH_SUCCESS:
      return state.set('insertResult', action.response).set('isLoading', false);

    case INSERT_AUTH_FAILURE:
      return state.set('isLoading', false);

    // Temp file cases below //
    // case GET_DUPLICATE_TEMP_AUTHS_REQUEST:
    //   return state.set('isLoading', true);

    // case GET_DUPLICATE_TEMP_AUTHS_SUCCESS:
    //   return state
    //     .set('duplicateAuths', action.response)
    //     .set('isLoading', false);

    // case GET_DUPLICATE_TEMP_AUTHS_FAILURE:
    //   return state.set('isLoading', false);

    case GET_PENDING_AUTH_FILES_DOCS_REQUEST:
      return state.set('isLoading', true);

    case GET_PENDING_AUTH_FILES_DOCS_SUCCESS:
      return state
        .set('authDocuments', action.response)
        .set('isLoading', false);

    case GET_PENDING_AUTH_FILES_DOCS_FAILURE:
      return state.set('isLoading', false);

    case GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_REQUEST:
      return state.set('isLoading', true);

    case GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_SUCCESS:
      return state
        .set('clientFields', action.response)
        .set('isLoading', false);

    case GET_PENDING_AUTH_FILE_CUSTOM_FIELDS_FAILURE:
      return state.set('isLoading', false);

    case GET_CLIENT_INFORMATION_REQUEST:
      return state.set('isLoading', true);

    case GET_CLIENT_INFORMATION_SUCCESS:
      return state
        .set('clientInfo', action.response)
        .set('isLoading', false);

    case GET_CLIENT_INFORMATION_FAILURE:
      return state.set('isLoading', false);

    case GET_TEMP_AUTH_FILES_REQUEST:
      return state.set('isLoading', true);  

    case GET_TEMP_AUTH_FILES_SUCCESS:
      return state
        .set('pendingAuthorizations', action.response.filter((file) => file.tempFile.tempFileStatusId === '1777f26f-7158-4faf-94c1-399362f76bea'))
        .set('submittedAuths', action.response.filter((file) => file.tempFile.tempFileStatusId === 'd5c8254f-e3d2-42ba-8293-a1aa9a1cfa57'))
        .set('isLoading', false);

    case GET_PENDING_AUTH_FILE_REQUEST:
      return state.set('isLoading', true);

    case GET_PENDING_AUTH_FILE_SUCCESS:
      return state
        .set('pendingAuthorization', action.response)
        .set('isLoading', false);

    case GET_TEMP_AUTH_FILES_FAILURE:
      return state.set('isLoading', false);

    case GET_TEMP_FILES_BY_MONTH_REQUEST:
      return state.set('isLoading', true);

    case GET_TEMP_FILES_BY_MONTH_SUCCESS:
      return state
        .set('authCountsByMonth', defaultMonthData(action.response.map((item) => ({...item, monthNumber: parseInt(item.monthNumber)}))))
        .set('isLoading', false);

    case GET_PENDING_AUTH_FILE_FAILURE:
      return state.set('isLoading', false);

    case GET_TEMP_FILES_BY_MONTH_FAILURE:
      return state.set('isLoading', false);

    case GET_TEMP_FILES_BY_PROGRAM_REQUEST:
      return state.set('isLoading', true);

    case GET_TEMP_FILES_BY_PROGRAM_SUCCESS:
      return state
        .set('authCountsByProgram', action.response)
        .set('isLoading', false);

    case GET_TEMP_FILES_BY_PROGRAM_FAILURE:
      return state.set('isLoading', false);
    
    // Temp file cases above ^ //

    // Enumeration cases below //

    case GET_ALL_ENUMERATIONS_SUCCESS:
      return state.set('allEnums', action.response).set('isLoading', false);

    case GET_ALL_COUNTRIES_SUCCESS:
      return state.set('countryEnums', sortCountries(action.response)).set('isLoading', false);

    case GET_ALL_PROVINCES_SUCCESS:
      return state.set('provinceEnums', sortProvinces(action.response)).set('isLoading', false);

    // Enumeration cases above ^ //

    default:
      return state;
  }
}
